import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form } from 'reactstrap';
import { Button } from '../../../components/Component';

const SectionEditModal = ({ show, onHide, section, onSave, isLoading }) => {
    const [sectionName, setSectionName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (section) {
            setSectionName(section.name || '');
        } else {
            setSectionName('');
        }
        setError('');
    }, [section, show]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!sectionName.trim()) {
            setError('Section name cannot be empty.');
            return;
        }
        setError('');
        onSave({ 
            id: section?.id || null, 
            name: sectionName.trim() 
        });
    };

    const handleClose = () => {
        setError('');
        setSectionName('');
        onHide();
    };

    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                {section ? 'Edit Section' : 'Create New Section'}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {error && <p className="text-danger">{error}</p>}
                    <FormGroup>
                        <Label htmlFor="sectionName">Section Name *</Label>
                        <Input
                            type="text"
                            id="sectionName"
                            value={sectionName}
                            onChange={(e) => setSectionName(e.target.value)}
                            placeholder="Enter section name"
                            disabled={isLoading}
                            required
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={handleClose} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" disabled={isLoading}>
                        {isLoading ? (section ? 'Saving...' : 'Creating...') : (section ? 'Save Changes' : 'Create Section')}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default SectionEditModal; 